import React, { useState, useEffect } from "react";
import Hero from "../components/Hero/Hero";
import DemoSection from "../components/DemoSection/DemoSection";
import Feature from "../components/Feature/Feature";
import Carousel from "../components/Carousel/Carousel";
import WhoWeAre from "../components/WhoWeAre/WhoWeAre";
import MentorPopup from "../components/MentorPopup/MentorPopup";
import Footer from "../components/Footer/Footer";
import VideoSection from "../components/Video/VideoSection";
import ContactUs from "../components/ContactUs/ContactUs";
import Team from "../components/Team/Team";
import Gallery2 from "../components/Gallery2/Gallery2";
import Navbar from "../components/Navbar/Navbar";

const ENABLE_EXPERT_POPUP = false;

const HomePage = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    window.onload = function () {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 9000);

      return () => clearTimeout(timer);
    };
  }, []);

  const handleClose = () => {
    setShowPopup(false);

    setTimeout(() => {
      setShowPopup(true);
    }, 60000);
  };

  return (
    <div>
      <Navbar />
      <Hero id="hero-section" />
      <DemoSection id="demo-section" />
      <VideoSection />
      <WhoWeAre id="about" />
      <Feature id="feature-section" />
      <Carousel id="carousel-section" />
      <Team id="team-section" />
      <Gallery2 id="gallery2" />
      <div className="contact-main-div">
        <ContactUs />
      </div>
      <Footer id="Footer-section" />
      {ENABLE_EXPERT_POPUP && showPopup && (
        <MentorPopup onClose={handleClose} />
      )}
    </div>
  );
};

export default HomePage;
